import React, { Component } from 'react';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemText from '@material-ui/core/ListItemText';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import Collapse from '@material-ui/core/Collapse';
import Checkbox from '@material-ui/core/Checkbox';

import OhlListItem from './listItemOhl';


export class OHLList extends Component {

    state = {
        open: false,
        checked: this.props.parentChecked
    }

    componentDidUpdate(prevProps){
        if(prevProps.parentChecked !== this.props.parentChecked){
            this.setState({
                checked: this.props.parentChecked
            });
        }
    }

    onToogleOpen = () => {
        this.setState((previousState) => ({
            open: !previousState.open
        }));
    }

    onToogleVoltageLevelChecked = (e) => {
        this.setState((previousState) => ({
            checked: !previousState.checked
        }));

        this.props.onToogleOhlsChecked(this.props.ohlList.map(ohl => ohl.name), e.target.checked);
    }

    render() {

        let sortedList = this.props.ohlList.sort((a, b) => {
            var textA = a.name.toUpperCase();
            var textB = b.name.toUpperCase();
            return (textA < textB) ? -1 : (textA > textB) ? 1 : 0;
        });

        let listItemsList = sortedList.map(ohl => (
            <OhlListItem 
                name={ohl.name}
                key={ohl.name} 
                ohlId={ohl.ohlId}
                onToogleOhlChecked={(ohl, isChecked) => this.props.onToogleOhlChecked(ohl, isChecked)}
                centerOHLByName={this.props.centerOHLByName}
                //centerOHLById={this.props.centerOHLById}
                parentChecked={this.state.checked}
                isSelectable={this.props.isSelectable}
            />
        ));

        return (
                <List>
                    <div>
                        <ListItem  >
                            <ListItemText secondary={String(this.props.voltage) + ' kV ('+  String(sortedList.length) +')'} />
                            {this.props.isSelectable ? 
                                <Checkbox style={{marginRight: '10px'}}
                                    checked={this.state.checked}
                                    onChange={(e) => this.onToogleVoltageLevelChecked(e, this.props.name)}
                                    color='primary'
                                /> : null}
                            {this.state.open ? <ExpandLess onClick={this.onToogleOpen} /> : <ExpandMore onClick={this.onToogleOpen} />}
                        </ListItem>
                        <Collapse in={this.state.open} timeout="auto" >
                            <List component="div" >
                            {listItemsList}
                            </List>
                        </Collapse>
                    </div>
                </List>
        )
    }
}


export default OHLList;

